export default function getNotEqualQuery(itemId) {
  if (!itemId) return {};

  return {
    id: {
      _ne: itemId
    }
  };
}
